export const FACEBOOK_PIXEL_ID = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_ID as string;
export const FACEBOOK_PIXEL_ID_MEWING = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_ID_MEWING as string;
export const FACEBOOK_PIXEL_ID_ADQUANTUM = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_ID_ADQUANTUM as string;
export const FACEBOOK_PIXEL_ID_UNI = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_ID_UNI as string;
export const FACEBOOK_PIXEL_ID_CPM_TEST = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_ID_CPM_TEST as string;
export const FACEBOOK_PIXEL_ID_V18 = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_V18_ID as string;
export const FACEBOOK_PIXEL_ID_SEPTEMBER_2025 = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_ID_SEPTEMBER_2025 as string;
export const FACEBOOK_PIXEL_ID_ASYM = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_ID_ASYM as string;

export const BING_ID = process.env.NEXT_PUBLIC_BING_ID;
export const GA_ID = process.env.NEXT_PUBLIC_GA_ID;
export const GA_ID_V2 = process.env.NEXT_PUBLIC_GA_ID_V2;
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
export const PINTEREST_ID = process.env.NEXT_PUBLIC_PINTEREST_ID;
export const PINTEREST_ACCOUNT_ID =
  process.env.NEXT_PUBLIC_PINTEREST_ACCOUNT_ID;
export const TWITTER_ID = process.env.NEXT_PUBLIC_TWITTER_PIXEL_ID;
export const TIK_TOK_PIXEL = process.env.NEXT_PUBLIC_TIK_TOK_PIXEL_ID;
export const CLARITY_ID = process.env.NEXT_PUBLIC_CLARITY_ID;
export const CLARITY_V2_ID = process.env.NEXT_PUBLIC_CLARITY_V2_ID;
export const APPLOVIN_PIXEL_ID = process.env.NEXT_PUBLIC_APPLOVIN_PIXEL_ID;
export const APPLOVIN_ITEM_BRAND = 'Mimika';
export const APPLOVIN_ITEM_CATEGORY_ID = 2915;
export const APPLOVIN_ITEM_IMAGE_URL =
  'https://quiz.mimika-app.com/images/mimika-apsstore.png';
export const APPLOVIN_ITEM_LIST_ID = 'subscription_plans';

export const SNAPCHAT_PIXEL_ID = process.env
  .NEXT_PUBLIC_SNAPCHAT_PIXEL_ID as string;

import { isDevelopment } from 'src/utils';

export const ANALYTICS_ENDPOINT = process.env
  .NEXT_PUBLIC_API_ANALYTICS_ENDPOINT as string;
export const ANALYTICS_ENDPOINT_V2 = isDevelopment
  ? `${typeof window !== 'undefined' ? window.location.origin : ''}/api/analytics_v2/`
  : (process.env.NEXT_PUBLIC_API_ANALYTICS_ENDPOINT_V2 as string);

export const PINTEREST_EVENT_NAME_TO_RIGHT_CONVENTION = {
  AddToCart: 'add_to_cart',
  Checkout: 'checkout',
  Custom: 'custom',
  Lead: 'lead',
  PageVisit: 'page_visit',
  Search: 'search',
  Signup: 'signup',
  ViewCategory: 'view_category',
  WatchVideo: 'watch_video',
};

export const FACEBOOK_IDS = new Set(
  [
    FACEBOOK_PIXEL_ID,
    FACEBOOK_PIXEL_ID_ADQUANTUM,
    FACEBOOK_PIXEL_ID_UNI,
    FACEBOOK_PIXEL_ID_CPM_TEST,
    FACEBOOK_PIXEL_ID_V18,
    FACEBOOK_PIXEL_ID_MEWING,
    FACEBOOK_PIXEL_ID_SEPTEMBER_2025,
  ].filter(Boolean) as string[],
);

export const FACEBOOK_BACKEND_VARIANTS_MAP = new Map<string, string>([
  [FACEBOOK_PIXEL_ID, 'mimika'],
  [FACEBOOK_PIXEL_ID_MEWING, 'mimika_mewing'],
  [FACEBOOK_PIXEL_ID_CPM_TEST, 'mimika_cpm_test'],
  [FACEBOOK_PIXEL_ID_ADQUANTUM, 'mimika_adquantum_v16'],
  [FACEBOOK_PIXEL_ID_UNI, 'mimika_uni'],
  [FACEBOOK_PIXEL_ID_SEPTEMBER_2025, 'Mimika_September_2025'],
  [FACEBOOK_PIXEL_ID_ASYM, FACEBOOK_PIXEL_ID_ASYM],
]);

export const PIXEL_VARIANT_MAP = new Map<string, string | undefined>([
  ['mewing', FACEBOOK_PIXEL_ID_MEWING],
  ['mewingAg', FACEBOOK_PIXEL_ID_MEWING],
  ['mewingwomen', FACEBOOK_PIXEL_ID_MEWING],
  ['mewing22', FACEBOOK_PIXEL_ID_MEWING],
  ['variant21pix', FACEBOOK_PIXEL_ID_SEPTEMBER_2025],
  ['variant21of', FACEBOOK_PIXEL_ID_SEPTEMBER_2025],
  ['variant21_tr_m1', FACEBOOK_PIXEL_ID],
  ['variant21_tr_m2', FACEBOOK_PIXEL_ID_SEPTEMBER_2025],
  ['variant21_tr_y1', FACEBOOK_PIXEL_ID_SEPTEMBER_2025],
  ['mewing_tr_m1', FACEBOOK_PIXEL_ID_MEWING],
  ['mewing_tr_m2', FACEBOOK_PIXEL_ID_SEPTEMBER_2025],
  ['mewing_tr_y1', FACEBOOK_PIXEL_ID_SEPTEMBER_2025],
  ['maxi', FACEBOOK_PIXEL_ID_UNI],
  ['asymmetry', FACEBOOK_PIXEL_ID_UNI],
  ['mewing_tr_ch', FACEBOOK_PIXEL_ID_UNI],
  ['asymmetry_women', FACEBOOK_PIXEL_ID_UNI],
  ['asymmetry_np', FACEBOOK_PIXEL_ID_ASYM],
]);

export const SNAP_VARIANT_MAP = new Map<string, string | undefined>([
  ['mewing', SNAPCHAT_PIXEL_ID],
  ['variant21', SNAPCHAT_PIXEL_ID],
  ['variant21SP', SNAPCHAT_PIXEL_ID],
  ['MewingSP', SNAPCHAT_PIXEL_ID],
]);

export const SNAP_BACKEND_VARIANTS_MAP = new Map<string, string>([
  [SNAPCHAT_PIXEL_ID, 'mimika'],
]);

export const DEFAULT_FACEBOOK_PIXEL_IDS: Array<string | undefined> = [
  FACEBOOK_PIXEL_ID,
  FACEBOOK_PIXEL_ID_CPM_TEST,
  FACEBOOK_PIXEL_ID_ADQUANTUM,
];

export const TP_FACEBOOK_EVENT_NAMES = [
  'AddToCart',
  'StartTrial',
  'SecondScreen',
  'AddPaymentInfo',
  'ViewContent',
  'CompleteRegistration',
  'InitiateCheckout',
  'Subscribe',
  'Purchase',
  'Lead',
] as const;

export const TP_TIKTOK_EVENT_NAMES = [
  'AddPaymentInfo',
  'AddToCart',
  'AddToWishlist',
  'ClickButton',
  'CompletePayment',
  'CompleteRegistration',
  'Contact',
  'Download',
  'InitiateCheckout',
  'PlaceAnOrder',
  'Search',
  'SubmitForm',
  'Subscribe',
  'ViewContent',
] as const;

export const TP_APPLOVIN_EVENT_NAMES = [
  'page_view',
  'view_item',
  'add_to_cart',
  'begin_checkout',
  'add_payment_info',
  'purchase',
  'sign_up',
  'login',
  'generate_lead',
  'search',
  'subscribe',
  'remove_from_cart',
  'view_cart',
] as const;
